import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[fileNameContainSpecificSymbolsValidator]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: FileNameContainSpecificSymbolsValidator, multi: true }
    ],
    standalone: false
})
export class FileNameContainSpecificSymbolsValidator extends BaseValidator {

  private _value: string;

  @Input()
  public get fileNameContainSpecificSymbols(): string {
    return this._value;
  }

  public set fileNameContainSpecificSymbols(value: string) {
    this._value = value;
    if (this._onChange) this._onChange();
  }

  constructor() {
    super('fileNameContainSpecificSymbols');
  }

  protected getValidationResult(control: AbstractControl): ValidationErrors {
    if (control.value && control.value.indexOf("/") > -1) {
      return this.buildValidationErrorResult({});
    }

    return null;
  }
}
